import * as moment from 'moment-timezone';
import merge from 'lodash-es/merge';
import isObject from 'lodash-es/isObject';
import omitBy from 'lodash-es/omitBy';
import isEqual from 'lodash-es/isEqual';
import * as qs from 'qs';
import * as dictionary from "dict/static.json";
var config = dictionary['config'], defaultFilterParams = dictionary['defaultFilterParams'], utmList = [
    'utm_source', 'utm_medium', 'utm_campaign',
    'utm_term', 'utm_content', 'utm_landing',
    'gclid'
];
export function getAdminMenuTree() {
    return config.adminMenuTree;
}
export function getServerName() {
    return config.serverName;
}
export function RoundDateM(period) {
    var periodMap = ['hour', 'day', 'week', 'month', 'year'].reduce(function (o, k) { o[k] = 1; return o; }, {}), roundPeriod = period == 'week' ? 'isoWeek' : period;
    if (periodMap[period]) {
        return function (date, format) {
            return moment(date, format).tz(config.timezone).startOf(roundPeriod);
        };
    }
    else if (period == 'summary') {
        return function () {
            return moment(0).tz(config.timezone);
        };
    }
    else if (period == 'origin') {
        return function (date) {
            return moment(date).tz(config.timezone);
        };
    }
    else if (period == 'now') {
        var dateM_1 = moment().tz(config.timezone);
        return function () {
            return dateM_1;
        };
    }
    else {
        throw new Error('adminStat::RoundDateM: period not found');
    }
}
/**
 * Получить строку с параметрами для GET http-запроса.
 * @param {FilterParams} queryParams
 * @param {FilterParams} addParams
 * @returns {string}
 */
export function getUrlParams(queryParams, addParams) {
    var params;
    if (addParams) {
        Object.keys(addParams).forEach(function (p) {
            if (addParams[p]) {
                var data = {};
                data[p] = addParams[p];
                queryParams = merge({}, queryParams, data);
            }
        });
    }
    params = merge({}, getDiffParams(queryParams), { t: Date.now() });
    if (params.refGroup) {
        params.refGroup = encodeURIComponent(params.refGroup);
    }
    if (params.refSource) {
        params.refSource = encodeURIComponent(params.refSource);
    }
    return qs.stringify(params, { encode: false });
}
export function paramToQuery(params) {
    return qs.stringify(params, { encode: false });
}
export function limiter(cb, timeout) {
    if (timeout === void 0) { timeout = 300; }
    var timer = null;
    return function () {
        var that = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            cb.apply(that, args);
        }, timeout);
    };
}
export function getDiffParams(params) {
    // Оставить только параметры, отличные от дефолтных
    var diff = omitBy(params, function (v, k) {
        return defaultFilterParams[k] === v;
    });
    // Дополнительная проверка для объектов
    Object.keys(diff).forEach(function (key) {
        if (isObject(diff[key])) {
            if (isEqual(defaultFilterParams[key], diff[key])) {
                delete diff[key];
            }
        }
    });
    return diff;
}
export function getSiteStatusStyle(siteData) {
    var styles = {
        color: 'red'
    };
    // по какой-то причине не найден в БД
    if (siteData.notFound) {
        styles.color = 'LightGray';
        return styles.color;
    }
    // желтый - фантоманые, недоделанные в визарде
    if (siteData.markForRemovalAt) {
        styles.color = 'red';
    }
    else if (siteData.status == -1) {
        styles.color = 'rgb(216, 221, 18)';
    }
    // серый - выключенный
    else if (siteData.status == 0) {
        styles.color = 'gray';
    }
    // Если сайт активен
    else {
        // Если оплачен или включён на халяву
        if (siteData.paidType == 'paid' || siteData.paidType == 'trial' || siteData.inFreemiumMode) {
            // Если сайт опубликован
            if (siteData.datePublished) {
                styles.color = 'green';
            }
            else {
                styles.color = '#3b7694';
            }
        }
        // Сайт включен, но просрочен
        else {
            styles.color = 'red';
        }
    }
    return styles.color;
}
export function getUtmList() {
    return utmList;
}
export function getUTMhash(referer) {
    var result = {}, pairs = (referer || '').split('&');
    var utmListR = utmList.map(function (utm) {
        return {
            utm: utm,
            r: new RegExp(utm + '=((.*?){2,})')
        };
    });
    pairs.forEach(function (paid) {
        utmListR.forEach(function (utmItem) {
            if (paid.match(utmItem.utm)) {
                var val = paid.match(utmItem.r);
                if (val && val[1])
                    result[utmItem.utm] = val[1].replace(/(\/|\\)$/g, '');
            }
        });
    });
    return result;
}
export function getCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
export function getTimeAsIntervals(opts) {
    var start = opts.timestamp, period = opts.period, dates = [];
    if (period == 'day') {
        dates = [
            moment.utc(start).add(3, 'hour').startOf('day').format('DD.MM.YYYY'),
        ];
    }
    else {
        if (period == 'week') {
            dates = [
                moment.utc(start).add(3, 'hour').startOf('isoWeek').format('DD.MM.YYYY'),
                moment.utc(start).add(3, 'hour').endOf('isoWeek').format('DD.MM.YYYY')
            ];
        }
        else if (period == 'month') {
            dates = [
                moment.utc(start).add(3, 'hour').startOf('month').format('DD.MM.YYYY'),
                moment.utc(start).add(3, 'hour').endOf('month').format('DD.MM.YYYY')
            ];
        }
        else if (period == 'year') {
            dates = [
                moment.utc(start).add(3, 'hour').startOf('year').format('DD.MM.YYYY'),
                moment.utc(start).add(3, 'hour').endOf('year').format('DD.MM.YYYY')
            ];
        }
        else if (period == 'summary') {
            dates = [
                ''
            ];
        }
    }
    return dates;
}
/**
 * Установить куку. Взято отсюда "http://learn.javascript.ru/cookie".
 * @param name
 * @param value
 * @param options
 */
export function setCookie(name, value, options) {
    options = options || {};
    var expires = options.expires;
    if (typeof expires == "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }
    value = encodeURIComponent(value);
    var updatedCookie = name + "=" + value;
    Object.keys(options).forEach(function (propName) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    });
    document.cookie = updatedCookie;
}
export function parseDate() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return moment.apply(this, args).tz(config.timezone);
}
export var currencyLabels = {
    all: 'All',
    usd: '$',
    // rub : '<span style="font-family: PT Rouble;">у</span>',
    rub: 'R',
    brl: 'R$',
    pln: 'zł',
    ngn: '₦'
};
export function mergeFilterParams() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return merge.apply(void 0, [{}].concat(args));
}
